export const OFFLINE_TITLE = 'OFFLINE MODE';
export const OFFLINE_DESC = 'functionality may be limited';
